import React from "react";
import FinlabsBanners from '../../template/images/finlabsBanner.png';
import './home.css';


const FinlabsBanner = (props) => {
    const { uspTitle, description } = props;

    const navigateTo = () => {
         window.open('https://finlabsindia.org/solutions/', '_blank', 'noopener,noreferrer');
    };

    return (
        <React.Fragment>
            <div className="finlabsBanner_sec_main_title">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div className="finlabsBanner_inner">
                                <div className="finlabsBanner">
                                    <h2 className="finlabsBanner_title">Explore Our Other Solutions For Learning & Development</h2>
                                    <p className="finlabsBanner_description">Take a deep dive into our suite of innovative solutions designed to empower you with our swiftOnboarding, content services and beyond.</p>
                                    <div className="hero_button_main">
                                        <button className="hero_Explore_btn" 
                                        onClick={navigateTo}
                                        >Explore Solutions</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div className="finlabsBanner_inner">
                                <div className="finlabsBanner_image_main">
                                    <img src={FinlabsBanners} className="finlabsBanner_image img-fluid"></img>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}

export default FinlabsBanner;